import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateTemplateCreationRecordRequest } from '../../contracts';
import {
  CREATE_TEMPLATE_CREATION_RECORD_KEY,
  GET_TEMPLATE_CREATION_RECORD_BY_ID,
} from '../../contracts';
import { createTemplateCreationRecord } from '../api/templates';
import { seedGetTemplateCreationRecordCache } from '../templateCreationRecordUseSections';

export const useMutateCreateTemplateCreationRecord = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [CREATE_TEMPLATE_CREATION_RECORD_KEY],
    mutationFn: async (request: CreateTemplateCreationRecordRequest) => {
      const { data: templateCreationRecord } =
        await createTemplateCreationRecord(request);
      return templateCreationRecord;
    },
    onSuccess: (data, request) => {
      queryClient.setQueryData(
        [GET_TEMPLATE_CREATION_RECORD_BY_ID, { templateCreationRecordId: data.id }],
        seedGetTemplateCreationRecordCache(data, request.use_sections)
      );
    },
  });
};
